import type { JSX } from 'react';

import { Separator } from '@change/ds-core-ui';
import { Grid } from '@change/ds-layout';

import { FormFooter } from '../components/FormFooter';
import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { usePageBody } from '../components/PageBody/hooks/usePageBody';
import { PageBreadcrumb } from '../components/PageBreadcrumb';
import { StrengthTips } from '../components/strengthTips/StrengthTips';

export function Layout(): JSX.Element {
	const {
		data: { selectedTab },
	} = usePageBody();

	return (
		<>
			<Grid className="gap-0! p-0! lg:gap-0!">
				<div className="col-span-full">
					<PageBanner />
					<PageBreadcrumb />
				</div>
				{selectedTab !== 'edit' && <Separator className="sm:-mt-1 md:mt-0" />}
			</Grid>
			{/* StrengthTips is intentionally outside the Grid so it can be full width. It uses Grid internally */}
			{selectedTab === 'edit' && <StrengthTips />}
			<Grid className="gap-0! p-0! lg:gap-0!">
				<div className="col-span-full">
					<PageBody />
					{selectedTab === 'edit' && <FormFooter />}
				</div>
			</Grid>
		</>
	);
}
